import type { ToggleButtonDesignTokens, ToggleButtonTokenSections } from '@openng/optimus-ui-themes/types/togglebutton';

/**
 * The small and large sizes give the select's box below 768px: the 1rem text the select inherits and the form field's
 * vertical padding, split evenly between the track (`root`) and the pressed pill (`content`). From 768px the switch
 * field takes the form field size steps instead.
 */
export const root: ToggleButtonTokenSections.Root = {
	padding: '0.5rem 1rem',
	sm: {
		fontSize: '1rem',
		padding: '{togglebutton.padding.y} 0.75rem',
	},
	lg: {
		fontSize: '1rem',
		padding: '{togglebutton.padding.y} 1.25rem',
	},
};

export const content: ToggleButtonTokenSections.Content = {
	sm: {
		padding: '{togglebutton.padding.y} 0.75rem',
	},
	lg: {
		padding: '{togglebutton.padding.y} 0.75rem',
	},
};

export const extend: ToggleButtonTokenSections.Extend = {
	paddingY: '{form.field.padding.y} / 2',
};

export default {
	root,
	content,
	extend,
} satisfies ToggleButtonDesignTokens;
